// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_025a50318d--tooltip--3bdcq","arrow_tooltip":"_025a50318d--arrow_tooltip--1ss75","arrow":"_025a50318d--arrow--6NUSu","close":"_025a50318d--close--12u3d"};